"use client";

import { useTranslation } from "react-i18next";

const termKeys = [
  { title: "acceptance", content: "acceptanceContent" },
  { title: "bookingRules", content: "bookingRulesContent" },
  { title: "payments", content: "paymentsContent" },
  { title: "userResponsibilities", content: "userResponsibilitiesContent" },
  { title: "liability", content: "liabilityContent" },
  { title: "changes", content: "changesContent" },
] as const;

export default function TermsPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-background">
      <section className="bg-gradient-to-r from-primary-strong to-primary py-10 text-white sm:py-14 md:py-16">
        <div className="mx-auto w-full max-w-4xl px-4 sm:px-6">
          <h1 className="text-2xl font-black tracking-tight sm:text-3xl md:text-4xl">
            {t("terms.title")}
          </h1>
          <p className="mt-2 text-base text-white/90 sm:mt-3 sm:text-lg">{t("terms.subtitle")}</p>
        </div>
      </section>
      <section className="py-10 sm:py-14 md:py-16">
        <div className="mx-auto w-full max-w-4xl space-y-6 px-4 sm:space-y-8 sm:px-6">
          {termKeys.map(({ title, content }) => (
            <div
              key={title}
              className="min-w-0 overflow-hidden rounded-2xl border border-border-soft bg-white p-4 shadow-md sm:rounded-3xl sm:p-6"
            >
              <h2 className="text-base font-semibold text-slate-900 sm:text-xl">
                {t(`terms.${title}`)}
              </h2>
              <p className="mt-3 text-sm leading-6 text-slate-600">
                {t(`terms.${content}`)}
              </p>
            </div>
          ))}
          <p className="text-sm text-slate-600">
            {t("terms.questions")}{" "}
            <a
              className="font-semibold text-primary"
              href="mailto:legal@bigsport.io"
            >
              legal@bigsport.io
            </a>
            .
          </p>
        </div>
      </section>
    </div>
  );
}
